<template>
  <div class="team">
    <toolbar>
      <template v-slot:left>
        Team Admins
      </template>
      <template v-slot:center>
        <text-input v-model="searchValue" placeholder="Add or search admins" />
      </template>
      <template v-slot:right>
        <button class="g-button" @click="save" :disabled="invalidEmail || isSaving">Add</button>
      </template>
    </toolbar>
    <div class="team__users">
      <loader v-if="!getUsers" />
      <div v-else>
        <list v-for="email in users" :key="email">
          <template v-slot:left>{{email}}</template>
          <template v-slot:right>
            <span v-if="isUser(email)">You</span>
            <a v-else @click="remove(email)">Remove</a>
          </template>
        </list>
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import { mapGetters, mapActions } from 'vuex';
import isEmail from '@/utilities/isEmail';
import Loader from '@/components/Loader.vue';
import List from '@/components/List.vue';
import Toolbar from '@/components/Toolbar.vue';
import TextInput from '@/components/TextInput.vue';

export default {
  name: 'Team',
  beforeCreate() {
    this.$store.dispatch('fetchSite');
  },
  components: {
    Loader,
    List,
    Toolbar,
    TextInput,
  },
  data() {
    return {
      isSaving: false,
      searchValue: null,
    };
  },
  computed: {
    ...mapGetters(['getUser', 'getSite']),
    invalidEmail() {
      return !isEmail(this.searchValue) || this.users.includes(this.searchValue);
    },
    getUsers() {
      return this.getSite && this.getSite.adminUsers;
    },
    searchAPI() {
      return new Fuse(this.getUsers, {
        threshold: 0.0,
      });
    },
    users() {
      const { searchValue } = this;
      if (searchValue) {
        return this.searchAPI.search(searchValue).map(result => result.item);
      }
      return this.getUsers;
    },
  },
  methods: {
    ...mapActions(['addAdmin', 'removeAdmin']),
    isUser(email) {
      return this.getUser.email === email;
    },
    save() {
      this.isSaving = true;
      this.addAdmin(this.searchValue).then(() => {
        this.searchValue = null;
        this.isSaving = false;
      });
    },
    remove(email) {
      this.removeAdmin(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.team {
  max-width: 1200px;
  margin: 0 auto;
  &__users {
    max-width: 520px;
    margin: 30px auto;
  }
}
</style>
